import { useId, useState, type ChangeEvent } from 'react'
import { _x } from '@wordpress/i18n'
import { useMenu } from 'react-instantsearch'
import FilterTag from './FilterTag'
import { WP_LOCALE } from '../../../utils/algolia/algoliaLocalization'

export default function TagFilter(props: {
  className?: string
  attribute: string
  limit?: number
  title: string
  ariaLabel: string
  isTranslatedAttribute?: boolean
}) {
  const initialLimit = props.limit ?? 10
  const [limit, setLimit] = useState(initialLimit)

  const attribute = props.isTranslatedAttribute
    ? `${props.attribute}.${WP_LOCALE}`
    : props.attribute

  const { items, refine, canToggleShowMore } = useMenu({
    attribute,
    showMore: true,
    showMoreLimit: Number.POSITIVE_INFINITY,
    limit: limit,
    sortBy: ['count:desc', 'name:asc']
  })

  const value = items.find((item) => item.isRefined)

  const onSelect = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedValue = event.target.value
    refine(selectedValue !== value?.value ? selectedValue : '')
  }

  const id = useId()

  const onShowMore = () => {
    setLimit((currentLimit) => currentLimit + initialLimit)
  }

  return (
    <fieldset className={props.className} aria-label={props.ariaLabel}>
      <legend className="filter-title">{props.title}</legend>
      <div className="filter-tags">
        {items.map((item) => (
          <FilterTag
            key={item.label}
            id={`filter-tag-${id}-${item.label}`}
            name={`filter-${id}`}
            value={item.value}
            label={item.label}
            checked={item.isRefined}
            onChange={onSelect}
          />
        ))}
      </div>
      {items.length < 1 && (
        <p className="filter-tags-empty-message">
          {_x('No filters available', 'Filter Tags Empty Message', 'icf')}
        </p>
      )}
      {canToggleShowMore && (
        <button
          type="button"
          className="filter-tags-show-more-button mt-1"
          onClick={onShowMore}
        >
          {_x('Show More', 'Filter Tags Show More Button', 'icf')}
        </button>
      )}
    </fieldset>
  )
}
